module.exports = __webpack_public_path__ + "img/RodoS.58c3e2f2.jpg";